import { Component } from '@angular/core';
import { CbIconModule } from '@chubb/ui-components';

@Component({
  selector: 'app-chubb-topbar',
  standalone: true,
  imports: [ CbIconModule ],
  templateUrl: './chubb-topbar.component.html',
  styleUrl: './chubb-topbar.component.scss'
})
export class ChubbTopbarComponent {
}
